import React from "react";
import UserAvatar from "../../../components/ui/icons/UserAvatar";

export interface TeamMemberBasic {
  id: number;
  first_name: string;
  last_name: string;
  image: string | null;
  completed_per?: number;
}

interface MemberAvatarStackProps {
  members: TeamMemberBasic[];
  maxVisible?: number;
  size?: string;
}

const MemberAvatarStack: React.FC<MemberAvatarStackProps> = ({
  members,
  maxVisible = 3,
  size = "w-9 h-9",
}) => {
  const visible = members.slice(0, maxVisible);
  const remaining = members.length - maxVisible;

  return (
    <div className="flex items-center" style={{ paddingRight: 10 }}>
      {visible.map((m, i) => (
        <div
          key={m.id}
          className="relative group"
          style={{
            marginLeft: i === 0 ? 0 : -8,
            zIndex: visible.length - i,
          }}
        >
          <UserAvatar
            src={m.image ?? ""}
            className={`${size} border-[2.5px] border-white flex-shrink-0 ring-0 cursor-pointer`}
          />
          {/* Tooltip */}
          <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-[#26295e] text-white text-[10px] font-primary font-medium px-2 py-1 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all duration-150 pointer-events-none z-50 shadow-lg">
            {m.first_name} {m.last_name}
            <div className="absolute top-full left-1/2 -translate-x-1/2 border-[3px] border-transparent border-t-[#26295e]" />
          </div>
        </div>
      ))}

      {remaining > 0 && (
        <div
          className={`${size} rounded-full flex items-center justify-center text-white text-[10px] font-bold border-[2.5px] border-white flex-shrink-0`}
          style={{
            background: "linear-gradient(135deg, #5d4cc6, #3b519c)",
            marginLeft: -8,
            zIndex: 0,
          }}
        >
          +{remaining}
        </div>
      )}
    </div>
  );
};

export default MemberAvatarStack;
